import React, { useEffect, useState } from 'react';
import { Layout } from './shared';
import { getDocumentBySlugClient } from '../lib/documents';
import MarkdownPage from './MarkdownPage';

const PrivacyPage = ({ openRequestModal }) => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [docHtml, setDocHtml] = useState('');
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsPageLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let isCancelled = false;
    async function loadDoc() {
      try {
        const doc = await getDocumentBySlugClient('privacy-policy');
        if (!isCancelled) setDocHtml(doc.contentHtml || '');
      } catch (e) {
        if (!isCancelled) {
          setLoadError(true);
          setDocHtml('');
        }
      }
    }
    loadDoc();
    return () => { isCancelled = true; };
  }, []);

  return (
    <div className={`transition-opacity duration-1000 ease-out ${
      isPageLoaded ? 'opacity-100' : 'opacity-0'
    }`}>
      <Layout openRequestModal={openRequestModal}>
        {/* Hero Section */}
        <section className="px-6 py-20 bg-gradient-to-br from-white via-blue-50 to-sky-200">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Privacy Policy
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-2 leading-relaxed max-w-3xl mx-auto">
              Our commitment to your data privacy and protection
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="px-6 py-16 bg-white">
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-10">
              <div className="prose max-w-none prose-headings:scroll-mt-24 text-left prose-h1:text-left prose-h2:text-left prose-h3:text-left prose-p:text-left prose-li:text-left">
                {loadError || !docHtml ? (
                  <MarkdownPage filePath="/documents/privacy-policy.md" />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: docHtml }} />
                )}
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </div>
  );
};

export default PrivacyPage;


